import Rebase from 're-base';
import firebase from 'firebase';

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBz0DP7GEIHO4eUx6usvfXp1cmUERil6iQ",
    authDomain: "catch-of-the-day-mongejp.firebaseapp.com",
    databaseURL: "https://catch-of-the-day-mongejp.firebaseio.com",
});

const base = Rebase.createClass(firebaseApp.database());

export {firebaseApp};

export default base;